<template>
	<div class="">
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<!-- 系统设置 -->
		  <el-tabs type="border-card" v-model="tabIndex" @tab-click="handleClick">
		    <el-tab-pane label="基础设置">
		      <el-form label-width="120px" label-position="left">
		          <el-form-item label="系统名称" prop="shop_name">
		             <el-input :value="shop_name" @input="vModel('shop_name',$event)" placeholder="请输入系统名称" size="small"></el-input>
		          </el-form-item>
				  <el-form-item label="系统全名" prop="system_name">
				     <el-input :value="system_name" @input="vModel('system_name',$event)" placeholder="请输入系统全名" size="small"></el-input>
				  </el-form-item>
		          <el-form-item label="备案信息" prop="shop_beian">
		             <el-input :value="shop_beian" @input="vModel('shop_beian',$event)" placeholder="请输入备案信息" size="small"></el-input>
		          </el-form-item>
				  <el-form-item label="系统描述" prop="shop_desc">
				     <el-input :value="shop_desc" @input="vModel('shop_desc',$event)" placeholder="请输入系统描述" size="small" type="textarea" :rows="3"></el-input>
				  </el-form-item>
				  <el-form-item label="搜索关键字">
					<el-input placeholder="请输入搜索关键字" size="small" :value="search_keywords" @input="vModel('search_keywords',$event)"></el-input>
					<small class="ml-1 text-secondary">多个关键字，空格分隔</small>
				  </el-form-item>
				  <el-form-item>
					<el-button type="primary" size="small" @click="submit">确定</el-button>
				  </el-form-item>
		      </el-form>
		    </el-tab-pane>
			<el-tab-pane label="客服设置">
			  <el-form label-width="120px" label-position="left">
			      <el-form-item label="客服二维码">
					  <el-upload
						class="upload-border"
						action="/manage/images/upload"
						:show-file-list="false"
						:on-success="uploadSuccess">
						<img v-if="kf_ewm" :src="kf_ewm" class="w-100 h-100">
						<i v-else class="el-icon-plus uploader-icon"></i>
					  </el-upload>
				  </el-form-item>
				  <el-form-item label="客服QQ" prop="kf_qq">
				     <el-input :value="kf_qq" @input="vModel('kf_qq',$event)" placeholder="请输入客服QQ" size="small"></el-input>
				  </el-form-item>
				  <el-form-item label="客服微信号" prop="kf_wechat">
				     <el-input :value="kf_wechat" @input="vModel('kf_wechat',$event)" placeholder="请输入客服微信号" size="small"></el-input>
				  </el-form-item>
				  <el-form-item label="客服电话" prop="kf_mobile">
				     <el-input :value="kf_mobile" @input="vModel('kf_mobile',$event)" placeholder="请输入客服电话" size="small"></el-input>
				  </el-form-item>
				  <el-form-item>
					<el-button type="primary" size="small" @click="submit">确定</el-button>
				  </el-form-item>
			  </el-form>
			</el-tab-pane>
			<el-tab-pane label="分红时间">
			  <el-form label-width="120px" label-position="left">
			      <el-form-item label="分红时间" prop="" style="width: 450px;">
					  <div class="w-100 flex align-center">
						<el-time-picker
							:value="fh_time" 
							@input="vModel('fh_time',$event)"
							value-format="HH:mm:ss"
							placeholder="分红时间">
						  </el-time-picker>
					  </div>
				 </el-form-item>
				  <el-form-item>
					<el-button type="primary" size="small" @click="submit">确定</el-button>
				  </el-form-item>
			  </el-form>
			</el-tab-pane>
			<el-tab-pane label="提现设置">
			  <el-form label-width="120px" label-position="left">
				 <el-form-item label="开启">
					 <el-switch
					   :value="is_tocash"
					   @input="vModel('is_tocash',$event)"
					   :active-value="1"
					   :inactive-value="2"
					   active-color="#13ce66"
					   inactive-color="#ff4949"
					 />
				   </el-form-item>
				   <el-form-item label="提现最小金额" prop="" style="width: 450px;">
					  <div class="w-100 flex align-center">
						<el-input :value="tocash_money_low" @input="vModel('tocash_money_low',$event)" type="number" placeholder="请输入提现最小金额" size="small" clearable class="flex-1"></el-input>
						<span class="ml-2"></span>
					  </div>
				   </el-form-item>
				  <el-form-item label="每日提现上限" prop="" style="width: 450px;">
					  <div class="w-100 flex align-center">
						<el-input :value="tocash_money_limit" @input="vModel('tocash_money_limit',$event)" type="number" placeholder="请输入每日提现上限" size="small" clearable class="flex-1"></el-input>
						<span class="ml-2"></span>
					  </div>
				  </el-form-item>
				  <el-form-item label="每日提现次数" prop="" style="width: 450px;">
					  <div class="w-100 flex align-center">
						<el-input :value="tocash_num_limit" @input="vModel('tocash_num_limit',$event)" type="number" placeholder="请输入每日提现次数" size="small" clearable class="flex-1"></el-input>
						<span class="ml-2"></span>
					  </div>
				  </el-form-item>
				  <el-form-item label="提现服务费率" prop="" style="width: 450px;">
					  <div class="w-100 flex align-center">
						<el-input :value="tocash_money_rate" @input="vModel('tocash_money_rate',$event)" type="number" placeholder="请输入提现服务费率" size="small" clearable class="flex-1"></el-input>
						<span class="ml-2">%</span>
					  </div>
				  </el-form-item>
				  <el-form-item>
					<el-button type="primary" size="small" @click="submit">确定</el-button>
				  </el-form-item>
			  </el-form>
			</el-tab-pane>
			<el-tab-pane label="分红设置">
			  <el-form label-width="120px" label-position="left">
				  <el-form-item label="推荐人分红" prop="" style="width: 450px;">
					  <div class="w-100 flex align-center">
						<el-input :value="tjr_rate" @input="vModel('tjr_rate',$event)" type="number" placeholder="请输入推荐人分红比例" size="small" clearable class="flex-1"></el-input>
						<span class="ml-2">%</span>
					  </div>
				  </el-form-item>
				  <el-form-item label="平台分红" prop="" style="width: 450px;">
					  <div class="w-100 flex align-center">
						<el-input :value="pt_rate" @input="vModel('pt_rate',$event)" type="number" placeholder="请输入平台分红比例" size="small" clearable class="flex-1"></el-input>
						<span class="ml-2">%</span>
					  </div>
				  </el-form-item>
				  <el-form-item>
					<el-button type="primary" size="small" @click="submit">确定</el-button>
				  </el-form-item>
			  </el-form>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import { mapState,mapMutations,mapGetters } from "vuex"
	import GlobalTips from "@/components/GlobalTips";
	export default {
		inject:['app'],
		components: {
			GlobalTips,
		},
		computed:{
			...mapState({
			  shop_name:state=>state.setting.shop_name,
			  company_name:state=>state.setting.company_name,
			  shop_address:state=>state.setting.shop_address,
			  shop_desc:state=>state.setting.shop_desc,
			  shop_beian:state=>state.setting.shop_beian,
			  // kf_mobile:state=>state.setting.kf_mobile,
			  search_keywords:state=>state.setting.search_keywords,
			  shop_logo:state=>state.setting.shop_logo,
			  system_name:state=>state.setting.system_name,
			  search_keywords:state=>state.setting.search_keywords,
			  kf_ewm:state=>state.setting.kf_ewm,
			  kf_qq:state=>state.setting.kf_qq,
			  kf_wechat:state=>state.setting.kf_wechat,
			  kf_mobile:state=>state.setting.kf_mobile,
			  fh_time:state=>state.setting.fh_time,
			  is_tocash:state=>parseInt(state.setting.is_tocash),
			  tocash_money_low:state=>state.setting.tocash_money_low,
			  tocash_money_limit:state=>state.setting.tocash_money_limit,
			  tocash_num_limit:state=>state.setting.tocash_num_limit,
			  tocash_money_rate:state=>state.setting.tocash_money_rate,
			  tjr_rate:state=>state.setting.tjr_rate,
			  pt_rate:state=>state.setting.pt_rate,
			}),
			...mapGetters([
			  'getData',
			]),
		},
		data() {
			return {
				tabIndex:0,
			}
		},
		mounted(){
		  this.getList()
		},
		methods:{
			...mapMutations(['editState','editParamsState']),
			vModel(key,val){
			  this.editState({key,val})
			},
			vModelParams(name,key,val){
			  this.editParamsState({name,key,val})
			},
			handleClick(tab, event) {
			 // console.log(tab, event);
			},
			getList(){
			  this.axios.get('/manage/setting/index').then(res=>{
				if(res.status){
				  if(res.data.length > 0){
					  this.$store.commit('initSetting',res.data)
				  }
				}
			  })
			},
			submit(){
			  this.axios.post('/manage/setting/save',this.getData).then(res=>{
				if(res.status){
				  this.$message.success(res.msg)
				}else{
				  this.$message.error(res.msg)
				}
			  })
			},
			uploadSuccess(e){
			   if(e.status){
				 this.vModel('kf_ewm',e.data.url)
			   }
			},
		}
	}
</script>

<style>
</style>